
export const BASE_URL = 'https://garage-backend-t9yd.onrender.com/api/v1'
